import { FC, HTMLAttributes, useMemo } from "react";
import { ITypographyProps } from "../Typography/Typography";
import { Image } from "@onmo/ui";
import clsx from "classnames";
import { useStyles } from "./CoinNumber.style";
import { getCurrencyIcon } from "../../../constants/wallet";
import { CoinType } from "@onmo/graphql/graphql";

// Mapping from legacy type prop values to CoinType enum
const LEGACY_TYPE_MAP: Record<string, CoinType> = {
  gem: CoinType.Gems,
  coin: CoinType.Gems,
  gzcoins: CoinType.GzTokens,
  vodabucks: CoinType.Vodabucks,
};

interface ICoinNumberProps extends ITypographyProps {
  amount: number;
  size?: number;
  type?: "vodabucks" | "gzcoins" | "gem" | "coin" | CoinType;
  reverse?: boolean;
  idCoin?: string;
}

export const CoinNumber: FC<
  ICoinNumberProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const {
    amount,
    size = 20,
    type = "gem",
    reverse,
    idCoin,
    ...otherProps
  } = props;
  const classes = useStyles();

  const coinIcon = useMemo(() => {
    const coinType = LEGACY_TYPE_MAP[type] || (type as CoinType);
    return getCurrencyIcon(coinType);
  }, [type]);

  return (
    <div
      className={clsx(classes.root, otherProps.className, { reverse })}
      {...otherProps}
    >
      <Image
        src={coinIcon.src}
        src2x={coinIcon.src2x}
        src3x={coinIcon.src3x}
        width={size}
        height={size}
        id={idCoin}
      />
      <span id={`${idCoin}-nb`}>{amount}</span>
    </div>
  );
};
